<div class="form-control-margin">
  <stx-checkbox-group
    layoutDirection="column"
    [formGroup]="formGroupReference"
    [options]="surgicalInterventionOptions"
  ></stx-checkbox-group>
</div>
